import React, {useState, useEffect} from "react";
import {
    Table,
    FormGroup,
    Checkbox,
    Glyphicon,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import {
    patchUser,
    getSharedCaps,
    getCaps,
    patchSharing
} from "../utils/bedrockAPI";
import {getUser, mobileCheck} from "../utils/Common";

export default function PowerNotifications({appNotificationsFromMaster, ...props}) {
    const [appNotifications, setAppNotifications] = useState(false);
    const [desktopNotifications, setDesktopNotifications] = useState(false);
    const [permissionState, setPermissionState] = useState();
    const [capShare, setCapShare] = useState(null);
    const [caps, setCaps] = useState(null);
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        let isMounted = true;

        navigator.permissions
        .query({ name: 'notifications' })
        .then(permission => {if(isMounted) setPermissionState(permission.state)});

        async function getCapShare(userId) {
            const tempShare = await getSharedCaps(userId);
            if(isMounted) {
                setCapShare(tempShare);
            
                const tempCaps = await getCaps();
                if(isMounted) {
                    setCaps(tempCaps);
                }
            }
        }

        const user = getUser();
        if(user) {
            getCapShare(user.userId);
            let updateUser = false;
            if(user.settings!=null) {
                if(user.settings.powerSummaryNotifications == null) {
                    user.settings.powerSummaryNotifications = false;
                    updateUser = true;
                }
                if(user.settings.email == null) {
                    user.settings.email = true;
                    updateUser = true;
                }
                if(isMounted)
                    setSettings(user.settings);
            } else {
                const tempSettings = {powerSummaryNotifications:false};
                user.settings = tempSettings;
                if(isMounted) {
                    setSettings(tempSettings);
                    updateUser = true;
                }
            }
            if(updateUser) {
                const newUser = {userId:user.userId,settings:user.settings};
                patchUser(user.userId,newUser)
            }
            if(user.settings && user.settings.appEnabled) {
                if(Notification.permission==="granted") {
                    if(isMounted)
                        setAppNotifications(true);
                }
            } else if(user.settings && user.settings.desktopEnabled) {
                if(Notification.permission==="granted") {
                    if(isMounted) {
                        setDesktopNotifications(true);
                    }
                }
            }
        }
        return () => { isMounted = false; };
    },[]);

    useEffect(() => {
        setAppNotifications(appNotificationsFromMaster);
    },[appNotificationsFromMaster]);

    useEffect(() => {
        let isMounted = true;

        if(permissionState==="granted") {
            const u = getUser();
            if(u.settings) {
                if(u.settings.appEnabled) {
                    if(isMounted)
                        setAppNotifications(true);
                } else if (u.settings.desktopEnabled) {
                    if(isMounted)
                        setDesktopNotifications(true);
                }
            }
        } else if (permissionState==="denied") {
            if(mobileCheck()) {
                if(isMounted)
                    setAppNotifications(false);
            } else {
                if(isMounted)
                    setDesktopNotifications(false);
            }
        }
        return () => { isMounted = false; };
    },[permissionState]);

    function getCapName(capId) {
        if(caps) {
            for(var i=0; i<caps.length; i++) {
                if(caps[i].capid===capId) {
                    return caps[i].neighborhood ? caps[i].name + ", "+caps[i].neighborhood : caps[i].name;
                }
            }
        }
    }

    async function handleSummaryChange() {
        var newSettings = JSON.parse(JSON.stringify(settings));
        newSettings.powerSummaryNotifications = !newSettings.powerSummaryNotifications;
        setSettings(newSettings);
        const user = getUser();
        const newUser = {userId:user.userId,settings:newSettings};
        await patchUser(user.userId,newUser);
    }

    async function handleNotificationChange(userCap,i,app=false) {
        if(app) {
            const currentAN = userCap.appNotifications;
            const newShare = {userCap:userCap.userCapId,appNotifications:!currentAN}
            await patchSharing(userCap.userCapId,newShare);
            let tempUserCap = JSON.parse(JSON.stringify(capShare));
            tempUserCap[i].appNotifications = !currentAN;
            setCapShare(tempUserCap);
        } else {
            const currentPN = userCap.powerNotifications;
            const newShare = {userCapId:userCap.userCapId,powerNotifications:!currentPN}
            await patchSharing(userCap.userCapId,newShare);
            let tempUserCap = JSON.parse(JSON.stringify(capShare));
            tempUserCap[i].powerNotifications = !currentPN;
            setCapShare(tempUserCap);
        }
    }

    const enableAppNotifications = (
        <Tooltip id="enableApp" style={{fontSize:"16px"}}>
            Enable app notifications in Master Controls to get per-camera power app notifications
        </Tooltip>
    )

    return (
        <div className="notifications-power">
            <div className="notifications-tab-header">
                <h2>Per-Camera Power Alerts</h2>
            </div>
            <Table condensed striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Camera</th>
                        <th>Email</th>
                        <th>App</th>
                    </tr>
                </thead>
                <tbody>
                    {getUser().role==="ADMIN" ? caps && capShare && caps.map((cap,i) => (
                        <React.Fragment key={i}>
                        {i===0 ? (
                            <tr>
                                <td colSpan={appNotifications ? 3 : 2} className="notifications-admin-note">
                                    Admin preview — showing a sample of caps
                                </td>
                            </tr>
                        ) : (cap.status === 'ACTIVE' || cap.status==='BUILD' ) && i<50 && (
                            <tr>
                                <td className="notifications-cap-name">{getCapName(cap.capid)}</td>
                                <td>
                                    <FormGroup controlId={`admin-email-${i}`}>
                                        <Checkbox checked={true} readOnly disabled>
                                            <Glyphicon glyph="envelope" />
                                        </Checkbox>
                                    </FormGroup>
                                </td>
                                {appNotifications ? (
                                    <td>
                                        <FormGroup controlId={`admin-app-${cap.capid}`}>
                                            <Checkbox disabled checked readOnly>
                                                <Glyphicon glyph="phone" />
                                            </Checkbox>
                                        </FormGroup>
                                    </td>
                                ) : (
                                    <OverlayTrigger placement="left" overlay={enableAppNotifications}>
                                        <td>
                                            <FormGroup controlId={`admin-app-disabled-${cap.capid}`}>
                                                <Checkbox disabled checked readOnly>
                                                    <Glyphicon glyph="phone" />
                                                </Checkbox>
                                            </FormGroup>
                                        </td>
                                    </OverlayTrigger>
                                )}
                            </tr>
                        )}
                        </React.Fragment>
                    )) : caps && capShare && capShare.map((cs,i) => (
                        <tr key={i}>
                            <td className="notifications-cap-name">{getCapName(cs.capId)}</td>
                            <td>
                                <FormGroup controlId={`power-email-${i}`}>
                                    <Checkbox checked={cs.powerNotifications} onChange={() => handleNotificationChange(cs,i)}>
                                        <Glyphicon glyph="envelope" />
                                    </Checkbox>
                                </FormGroup>
                            </td>
                            {appNotifications ? (
                                <td>
                                    <FormGroup controlId={`power-app-${cs.userCapId}`}>
                                        <Checkbox checked={cs.appNotifications} onChange={() => handleNotificationChange(cs,i,true)}>
                                            <Glyphicon glyph="phone" />
                                        </Checkbox>
                                    </FormGroup>
                                </td>
                            ) : (
                                <OverlayTrigger placement="left" overlay={enableAppNotifications}>
                                    <td>
                                        <FormGroup controlId={`power-app-disabled-${cs.userCapId}`}>
                                            <Checkbox disabled checked={cs.appNotifications} onChange={() => handleNotificationChange(cs,i,true)}>
                                                <Glyphicon glyph="phone" />
                                            </Checkbox>
                                        </FormGroup>
                                    </td>
                                </OverlayTrigger>
                            )}
                        </tr>
                    ))}
                </tbody>
            </Table>

            <div className="notifications-summary-row">
                <span className="notifications-summary-label">
                    Receive daily power summary emails
                </span>
                <FormGroup controlId="powerSummary">
                    <Checkbox
                        checked={settings ? settings.powerSummaryNotifications != null ? settings.powerSummaryNotifications : false : false}
                        onChange={handleSummaryChange}
                    >
                        <Glyphicon glyph="envelope" />
                    </Checkbox>
                </FormGroup>
            </div>
        </div>
    );
}
